var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.514,
    height: 20.39,
    viewBox: "0 0 20.514 20.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_5305154_fb_facebook_facebook_logo_icon_1_",
    "data-name": "5305154_fb_facebook_facebook logo_icon (1)",
    d: "M20.514,11.812A10.257,10.257,0,1,0,8.654,21.945V14.777H6.05V11.812h2.6V9.552a3.62,3.62,0,0,1,3.874-3.991,15.773,15.773,0,0,1,2.3.2V8.286H13.531a1.482,1.482,0,0,0-1.672,1.6v1.924H14.7l-.455,2.965H11.86v7.168A10.26,10.26,0,0,0,20.514,11.812Z",
    transform: "translate(0 -1.555)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.2cb0c9494003704aee469c45a0d1a0fa.svg";
export { ForwardRef as ReactComponent };